import { render, staticRenderFns } from "./productStatusSyncRulesModal.vue?vue&type=template&id=3bda3350&scoped=true"
import script from "./productStatusSyncRulesModal.vue?vue&type=script&lang=js"
export * from "./productStatusSyncRulesModal.vue?vue&type=script&lang=js"
import style0 from "./productStatusSyncRulesModal.vue?vue&type=style&index=0&id=3bda3350&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bda3350",
  null
  
)

export default component.exports